import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {tap} from 'rxjs';
import {AccountsWebservices} from '@webservices/accounts.webservices';
import {SessionStorageService} from '@services/session-storage.service';
import {LocalStorageService} from '@services/local-storage.service';
import {storageKey} from '@constants/storage.constants';
import {ForgotPasswordRequest} from '@core/models/auth.model';

@Injectable({providedIn: 'root'})
export class AuthService {

  constructor(
    private accountsApi: AccountsWebservices,
    private session: SessionStorageService,
    private local: LocalStorageService,
    private router: Router,
  ) {}

  getDeviceId(): string {
    let id = this.local.get<string>(storageKey.deviceId);
    if (!id) {
      id = crypto.randomUUID();
      this.local.set(storageKey.deviceId, id);
    }
    return id;
  }

  login(email: string, password: string) {
    return this.accountsApi.login({
      email,
      password,
      device_info: {device_id: this.getDeviceId(), device_type: 'web'},
    }).pipe(
      tap(res => {
        if (!res.error) {
          this.session.set(storageKey.token, res.data.access_token);
          this.session.set(storageKey.tokenType, res.data.token_type);
          this.session.set(storageKey.refreshToken, res.data.refresh_token);
        }
      })
    );
  }

  forgotPassword(email: string) {
    const payload: ForgotPasswordRequest = {email};
    return this.accountsApi.forgotPassword(payload);
  }

  logout(): void {
    this.session.clear();
    this.router.navigate(['/login']);
  }

  isLoggedIn(): boolean {
    return !!this.session.get(storageKey.token);
  }
}
